import AppMessage from './app-message';

export default AppMessage;